'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import { SmallCard } from '../../smallCard';

interface SliderProps {
  cards: {
    imageSrc: string;
    descriptionId: string;
    description: string;
    href?: string;
    alt: string;
  }[];
}

export const Slider: React.FC<SliderProps> = ({ cards }) => (
  <Swiper spaceBetween={12} slidesPerView="auto" className="!px-5 !py-2">
    {cards.map(({ imageSrc, descriptionId, description, href, alt }, index) => (
      <SwiperSlide key={index}>
        <SmallCard
          descriptionId={descriptionId}
          imageSrc={imageSrc}
          description={description}
          href={href}
          alt={alt}
          className="w-full"
        />
      </SwiperSlide>
    ))}
  </Swiper>
);
